<template>
	<div class="program-apply">
		<div class="page-container">
			<PageTitle ch="關於 駐村藝術家計畫"></PageTitle>
			<br />
			<br />
			<p class="explain">
				「利澤國際偶戲藝術村」致力於偶戲發展的創發平台，園區內備有排練場、木工廠、縫紉教室、手工教室、展演空間、藝術家住宿空間，2014年啟用以來，持續辦理國際大師班、偶戲推廣課程、導覽講座等，是為亞洲重要偶戲推動基地。
				<br />
				<br />
				自2017年起，以創意為核心，「研發」和「創新」為目標，提供與世界接軌的偶戲藝術平台，開始推動「駐村藝術家計畫」，旨在提供藝術家完善的創作空間與互動交流平台。本計劃每年透過不同主題邀請國內外藝術家來到利澤聚落，從體驗小村情調生活況味中激盪、創想與創作，為土地與人、為環境與自然，為在地的獨有注入新詮釋與文化蔓延。
				<br />
				<br />
				我們期望：
				<ul>
					<li>作為專業偶戲製作中心，串聯藝術家與社區合作屬於在地優秀創作</li>
					<li>持續引入國際藝術人才，豐富利澤文化能量，培育藝文種苗</li>
					<li>將偶戲多元豐富的表現形式連結傳統文化與地景，提高地方美學價值</li>
					<li>推動台灣當代偶戲的人才知能與國際影響力發展</li>
					<li>以亞洲唯一當代偶戲藝術村號召藝術家進駐，為台灣特色文化發聲</li>
				</ul>
				<br />
				<br />
				<b>ABOUT ARTIST-IN-RESIDENCE PROGRAM</b>
				<br />
				<br />
				Lìzé Puppet Art Colony in Yilan is a creative platform for puppet arts. Since 2014, Lìzé Puppet Art Colony has invited international puppet masters to hold workshops, puppet art promotion courses, studio guide tours, lectures, etc. The studio is equipped with rehearsal hall, woodshop, sewing room, artist work space and performance studio, making the colony an important platform in Asia for the development of puppet arts around the world.
				<br />
				<br />
				Since 2017, Lìzé Puppet Art Colony has organized the Artist-in-Residence Programs, which was planned to offer a consummate creating space and exchange platform for artists. Since the program started, it has successfully contributed to new creations and exchanges.
				<br />
				<br />
				The Artist-in-Residence Program is an art platform with creativity as its core and "R&D" and "innovation" as its goals. It is also an art platform that attempts to connect with the world. This plan invites domestic and foreign artists to come to the Lize settlement to experience the atmosphere of the small village and the taste of life, together to excite, create ideas and create, inject new interpretation and spread for the land and people, the environment and nature, and the uniqueness of the place. The Residency Project will continue to bring contemporary, innovative and socially involved creative thinking to this field through different themes each year.
			</p>
			<div class="master-hr">
				<div class="center">文件下載</div>
			</div>
			<div class="download">
				<a href="https://drive.google.com/file/d/11yr_WFWYX9SGN1TefxIX-N1-_e9dcP-2/view?usp=drive_link" download="駐村藝術家計畫申請簡章" target="_blank" class="download-btn">駐村藝術家計畫申請簡章</a>
				<a href="https://forms.gle/mPH15tkPYPYNxGqn6" download="駐村藝術家計畫申請網站" target="_blank" class="download-btn">駐村藝術家計畫申請網站</a>
				<a href="https://drive.google.com/file/d/11v72iRqm9eibzhv8Y2pmzje0wcSBg80E/view?usp=drive_link" download=" Prospectus of Artist in Residence Program " target="_blank" class="download-btn"> Prospectus of Artist in Residence Program </a>
				<a href="https://forms.gle/mPH15tkPYPYNxGqn6" download=" Application Website of Artist in Residence Program  " target="_blank" class="download-btn"> Application Website of Artist in Residence Program  </a>
			</div>
		</div>
	</div>
</template>

<script>
import PageTitle from "@/components/page_title";
import SpaceIntro from "@/components/space_intro";

export default {
	metaInfo: {
		title: "利澤國際偶戲藝術村"
	},
	name: "rent",
	data() {
		return {};
	},
	components: {
		PageTitle,
		SpaceIntro
	}
};
</script>

<style lang="scss" scoped>
b {
	font-weight: bold;
}
</style>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="sass">
@import '../../stylesheet/base.sass'
@import '../../stylesheet/layout.sass'
.program-apply
	.page-container
      +flexLayout('start2', 'col')

	.explain
		max-width: 788px
		width: 100%
		font-size: $font-size-3-s
		line-height: 2
		ul
			li
				position: relative;
				padding-left: 30px;
			li::before
				content: '\2713'
				position: absolute
				left: 0
				top: 50%
				transform: translateY(-50%)
				margin-right: 5px
				font-weight: 900

	.download
		margin-bottom: 70px
		.download-btn
          color: white
          max-width: 788px
          width: 100%
          font-size: $font-size-3
          padding: 25px 50px
          border-radius: 100px
          background-color: #01b6e2
          margin: 0 0 20px 0
          cursor: pointer
          display: block
		@media screen and (max-width: 900px)
			padding: 12px 25px
			line-height: 1.3
			font-size: 16px
			margin-bottom: 20px
	.master-hr
		border: 1px solid #01b6e2
		width: 100%
		border-width: 0 0 1px 0
		max-width: 788px
		margin: 60px 0
		position: relative

		.center
          position: absolute
          padding: 5px 10px
          background-color: white
          left: 50%
          top: 50%
          transform: translateX(-50%) translateY(-50%)
	@media all and (max-width: 790px)
		.explain
          padding: 0 15px
		.master-hr
          width: 95%
		.download-btn
          width: 95%
</style>



// WEBPACK FOOTER //
// src/pages/program/program_apply.vue